import { gql } from '~src/generated/portal/gql';

const SWITCH_PARTNER = gql(`
  mutation switchPartner($partnerId: String!) {
    switchPartner(partnerId: $partnerId) {
      id
      email
      selectedPartner {
        id
        name
      }
    }
  }
`);

export default SWITCH_PARTNER;
